"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const atoms_1 = require("../../atoms");
const S = (0, tslib_1.__importStar)(require("./styles"));
const IconLink = ({ title, url, icon, size, color = '#000', }) => ((0, jsx_runtime_1.jsxs)(S.IconLinkStyled, Object.assign({ to: url, title: title }, { children: [(0, jsx_runtime_1.jsx)(atoms_1.Icon, { icon: icon, size: size, color: color }, void 0), !title ? null : (0, jsx_runtime_1.jsx)(S.IconTitle, { children: title }, void 0)] }), void 0));
exports.default = IconLink;
